import React from "react";

// Import components
import Modal from "../Modal/Modal";

const ChecklistErrorModal = ({ openErrorModal, setOpenErrorModal }) =>
  openErrorModal ? (
    <Modal>
      <div className="checklist-modal-container">
        <div className="checklist-modal">
          <div className="checklist-modal-header">
            <button
              aria-label="Close modal"
              onClick={() => {
                setOpenErrorModal(false);
                window.scroll(0, 0);
              }}
              title="Close"
            >
              <i className="fa-regular fa-close" />
            </button>
            <h2>Something went wrong</h2>
          </div>
          <div className="checklist-modal-body">
            <p>An error occurred while submitting the form.</p>
            <p>Please try again.</p>
          </div>
          <div className="checklist-modal-footer">
            <button
              type="submit"
              onClick={() => {
                setOpenErrorModal(false);
                window.scroll(0, 0);
              }}
            >
              CLOSE
            </button>
          </div>
        </div>
      </div>
    </Modal>
  ) : null;

export default ChecklistErrorModal;
